import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  MockData,
  Service,
  Section,
} from "../interfaces/components/CostInterfaces/interfaces";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  IconButton,
} from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import nexumspinner from "../../assets/nexumspinner.gif";

interface DynamicTableProps {
  data: MockData | null;
}

const DynamicTable: React.FC<DynamicTableProps> = ({ data }) => {
  if (!data) {
    return (
      <div>
        <img
          style={{
            display: "flex",
            width: "23vh",
            height: "15vh",
            marginInline: "auto",
            marginTop: "10%",
          }}
          src={nexumspinner}
        />
      </div>
    );
  }

  const service = data.services;
  const record = service.map((service) => ({
    name: service.name,
    region: service.region,
    cost: service.cost, // Corrected typo in the property name
    sections: service.sections,
  }));

  return (
    <TableContainer
      component={Paper}
      sx={{ marginBottom: "20px", maxHeight: "430px" }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Region</TableCell>
            <TableCell>Estimated Cost</TableCell>
            <TableCell>Section Details</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {record.map((row, rowIndex) => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row">
                <b style={{ fontSize: "15px" }}>{row.name}</b>
              </TableCell>
              <TableCell>
                <b>{row.region}</b>
              </TableCell>
              <TableCell>
                <b>${row.cost}</b>
              </TableCell>
              <TableCell>
                {row.sections.map((section, sectionIndex) => (
                  <Accordion key={sectionIndex}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`section-content-${rowIndex}-${sectionIndex}`}
                      id={`section-header-${rowIndex}-${sectionIndex}`}
                    >
                      <Typography>
                        <b>&nbsp;&nbsp;&nbsp;{section.name}</b>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div>
                        {section.lines.map((line, lineIndex) => (
                          <p style={{ marginTop: "-1em" }} key={lineIndex}>
                            <Typography variant="body2">
                              {" "}
                              {line.includes("$") ? <span>&bull; </span> : null}
                              {line}
                            </Typography>
                          </p>
                        ))}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default function App() {
  const [data, setData] = useState<MockData | null>(null);

  const uid =
    window.sessionStorage.getItem("uid") === null
      ? "JEVZyG7f36S8BPNE6kSTryos43t1"
      : window.sessionStorage.getItem("uid");

  const idToken = window.sessionStorage.getItem("idToken") ?? "no-Token";

  useEffect(() => {
    const fetchData = async () => {
      let dfMessenger = document.getElementById("dfMessenger");
      const sid = dfMessenger?.getAttribute("session-id");
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/declarative_approach/cost/table`,
          {
            conversation_id: sid,
            user_id: uid,
            idToken: idToken,
          }
        )
        .then(function (response) {
          const data = JSON.parse(response.data) as MockData;
          setData(data);
        })
        .catch(async function (error) {
          //for receive the mock data when the api fall
          // const response = await axios.get<MockData>("/mockdatatable.json");
          //setData(response.data);

          console.error("Errore durante la chiamata API:", error);
        });
    };

    const timeout = setInterval(() => {
      fetchData();
    }, 2000);

    return () => {
      clearInterval(timeout);
    };
  }, []);

  /*--------------------------------------- USEEFFECT FOR MOCK DATA ---------------------------------------*/
  //useEffect(() => {
  //  const fetchData = async () => {
  //      try {
  //          const response = await axios.get<MockData>("/mockdatatable.json");
  //          setData(response.data);
  //      } catch (error) {
  //          console.error("Errore durante la chiamata API:", error);
  //      }
  //  };
  //
  //  fetchData();
  //}, []);

  return (
    <div>
      <DynamicTable data={data} />
    </div>
  );
}
